import { createReducer } from "@reduxjs/toolkit";
import { fetchStore } from "./actions";

export default createReducer(
  {
    status: "idle",
    name: "",
    logo: "",
    description: "",
    phone: "",
    pickupLocations: [],
    deliveryRanges: [],
    openingHours: [],
    openingHoursDaysOffset: 0,
    paymentTypes: [],
    deliveryTypes: [],
    minOrderValue: null,
    note: "",
    dailyMenuEnabled: true,
  },
  {
    [fetchStore.pending]: (state) => {
      state.status = "loading";
    },
    [fetchStore.rejected]: (state, { payload }) => {
      state.status = payload?.notFound ? "notFound" : "error";
    },
    [fetchStore.fulfilled]: (state, { payload }) => {
      state.status = "ready";
      state.name = payload.name;
      state.logo = payload.logo;
      state.description = payload.description;
      state.phone = payload.phone;
      state.deliveryTypes = payload.delivery_types;
      state.pickupLocations = payload.pickup_locations;
      state.openingHours = payload.opening_hours;
      state.openingHoursDaysOffset = payload.opening_hours_days_offset ?? 0;
      state.paymentTypes = payload.payment_types;
      state.minOrderValue = payload.min_order_value;
      state.note = payload.note;
      state.dailyMenuEnabled = payload.daily_menu_enabled;
    },
  }
);
